import { Typography } from "@material-tailwind/react";

export default function ContactPage() {
  const team = [
    {
      name: "Sumit Kumar Khandelwal",
      role: "Mentor",
      linkedin: "https://www.linkedin.com/in/sumit-khandelwal-aaa6b5103/",
    },
    {
      name: "Divyansh Bansal",
      role: "Developer",
      linkedin: "https://www.linkedin.com/in/divyansh-bansal-873610229/",
    },
    {
      name: "Divyansh Sinha",
      role: "Developer",
      linkedin: "https://www.linkedin.com/in/divyansh-sinha-aa8026226/",
    },
    {
      name: "Divyanshu Sinha",
      role: "Developer",
      linkedin: "https://www.linkedin.com/in/divyanshu-sinha-57a8aa24b/",
    },
  ];

  return (
    <div className="min-h-screen bg-[#F4F5F7] dark:bg-[#1E1E2E] p-6">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <Typography
            variant="h1"
            className="text-3xl font-bold mb-2 text-[#1F252E] dark:text-[#EAEAEA]"
          >
            Contact
          </Typography>
          <Typography className="text-[#4A5568] dark:text-[#B0B3B8]">
            Reach out to the development team
          </Typography>
        </div>

        {/* Team List */}
        <div className="space-y-4">
          {team.map((member, index) => (
            <div
              key={index}
              className="p-4 bg-white dark:bg-[#0D1117] rounded-lg border border-[#D1D5DB] dark:border-[#22232B]"
            >
              <Typography
                variant="h5"
                className="text-[#1F252E] dark:text-[#F8F9FA] mb-1"
              >
                {member.name}
              </Typography>
              <Typography className="text-[#6B7280] dark:text-[#B0B3B8] mb-2">
                {member.role}
              </Typography>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#3B82F6] hover:text-[#2563EB] dark:text-[#60A5FA] dark:hover:text-[#3B82F6]"
              >
                LinkedIn Profile
              </a>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="text-center mt-12">
          <Typography className="text-[#6B7280] dark:text-[#B0B3B8]">
            Delhi Technological University
          </Typography>
        </div>
      </div>
    </div>
  );
}
